import { BillingCyclePreviewProto } from "@noom/noom-contracts/noom_contracts/billing/bms/subscriptions/billing_cycle_preview";
import { InstallmentPlanProto } from "@noom/noom-contracts/noom_contracts/billing/bms/common/installment_plan";
import { PaymentPlanProto } from "@noom/noom-contracts/noom_contracts/billing/bms/invoices/payment_plan";

export function getInstallmentDataToUse({
  initialBillingCycle,
  recurringBillingCycle,
}: {
  initialBillingCycle?: BillingCyclePreviewProto;
  recurringBillingCycle?: BillingCyclePreviewProto;
}): {
  installmentPlan?: InstallmentPlanProto;
  paymentPlan?: PaymentPlanProto;
} {
  const initialInstallmentPlan = initialBillingCycle?.invoice?.installmentPlan;
  const initialPaymentPlan = initialBillingCycle?.invoice?.paymentPlan;
  if (initialInstallmentPlan && initialPaymentPlan) {
    return {
      installmentPlan: initialInstallmentPlan,
      paymentPlan: initialPaymentPlan,
    };
  }
  return {
    installmentPlan: recurringBillingCycle?.invoice?.installmentPlan,
    paymentPlan: recurringBillingCycle?.invoice?.paymentPlan,
  };
}
